import React, { useEffect, useState, Suspense } from "react";
import ReactGA from "react-ga4";
import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useLocation,
} from "react-router-dom";
import "../App.css";
import auth from "../utils/auth";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import CourseOverview from "./Courses/CourseOverview";
import Courses from "./Courses/Courses";
import ViewCourse from "./Courses/ViewCourse";
import Hire from "./Hire/Hire";
import Home from "./Home/Home";
import Certificate from "./Courses/Certificate";
import Dashboard from "./Dashboard";
import { IonApp, IonPage } from "@ionic/react";
import preferences from "../utils/preferences";
import RazorpayScreen from "./RazorpayScreen";

// Code-split: the admin dashboard is its own chunk, kept out of the public bundle.
const AdminApp = React.lazy(() => import("./Admin/AdminApp"));

const GA_TRACKING_ID = process.env.REACT_APP_TRACKING_ID;
if (GA_TRACKING_ID) {
	ReactGA.initialize(GA_TRACKING_ID);
}

const RequireAuth = ({ children }) => {
	if (!auth.isAuthenticated()) {
		return <Navigate to="/auth/login" replace />;
	}

	return children;
};

function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
		if (GA_TRACKING_ID) {
			ReactGA.send({ hitType: "pageview", page: pathname });
		}
	}, [pathname]);

	return null;
}

function App() {
	const [isInitialized, setIsInitialized] = useState(false);

	useEffect(() => {
		(async () => {
			await preferences.load();
			setIsInitialized(true);
		})();
	}, []);

	{
		return !isInitialized ? (
			<></>
		) : (
			<BrowserRouter>
				<IonApp>
					<ScrollToTop />
					<Routes>
						<Route path="/" exact element={<Home />} />
						<Route path="/auth/login" exact element={<Login />} />
						<Route path="/auth/register" exact element={<Register />} />
						<Route path="/enterprise" exact element={<Hire />} />
						<Route
							path="/courses/:courseID/view"
							exact
							element={
								<RequireAuth>
									<ViewCourse />
								</RequireAuth>
							}
						/>
						<Route
							path="/courses/:courseID"
							exact
							element={<CourseOverview />}
						/>
						<Route path="/courses" exact element={<Courses />} />
						<Route
							path="/certificate/:courseID"
							exact
							element={<Certificate />}
						/>
						<Route path="/dashboard" exact element={<Dashboard />} />
						<Route path="/razorpay" element={<RazorpayScreen />} />
						<Route
							path="/admin/*"
							element={
								<Suspense fallback={<div />}>
									<AdminApp />
								</Suspense>
							}
						/>
					</Routes>
				</IonApp>
			</BrowserRouter>
		);
	}
}

export default App;
